export default __webpack_public_path__ + "static/media/f-2.e872b0b0.png";